(function () {

  /*
   * ==========================================================
   * CALCULATE WHICH NOTES FIT
   * ==========================================================
   */

  function updateScentNotes() {

    const columns =
      document.querySelectorAll(
        '.scent-notes-column'
      );


    columns.forEach(function (column) {

      const itemsWrapper =
        column.querySelector(
          '.scent-notes-items'
        );


      if (!itemsWrapper) {
        return;
      }


      const items =
        Array.from(
          itemsWrapper.querySelectorAll(
            ':scope > .scent-note-item'
          )
        );


      const moreWrapper =
        itemsWrapper.querySelector(
          ':scope > .scent-notes-more-wrapper'
        );


      if (!moreWrapper) {
        return;
      }


      const moreButton =
        moreWrapper.querySelector(
          '.scent-notes-view-more'
        );


      const moreCount =
        moreWrapper.querySelector(
          '.scent-more-count'
        );


      const tooltip =
        moreWrapper.querySelector(
          '.scent-notes-tooltip'
        );


      /*
       * ------------------------------------------------------
       * RESET
       * ------------------------------------------------------
       */

      items.forEach(function (item) {

        item.style.display = '';
        item.style.flex = '0 0 auto';
        item.style.width = 'auto';
        item.style.maxWidth = 'none';

      });


      moreWrapper.style.display = 'none';

      moreWrapper.classList.remove(
        'is-open'
      );


      if (moreButton) {

        moreButton.setAttribute(
          'aria-expanded',
          'false'
        );

      }


      tooltip.innerHTML = '';


      /*
       * ------------------------------------------------------
       * No overflow if there are no notes
       * ------------------------------------------------------
       */

      if (!items.length) {
        return;
      }


      /*
       * ------------------------------------------------------
       * Get available width
       * ------------------------------------------------------
       */

      const availableWidth =
        itemsWrapper.clientWidth;


      /*
       * Gap between notes
       */

      const styles =
        window.getComputedStyle(
          itemsWrapper
        );


      const gap =
        parseFloat(styles.columnGap) ||
        parseFloat(styles.gap) ||
        0;


      /*
       * ------------------------------------------------------
       * Determine natural width of every note
       * ------------------------------------------------------
       *
       * We temporarily remove width restrictions.
       * This allows us to measure:
       *
       * IMAGE + NOTE NAME
       *
       * at their natural size.
       * ------------------------------------------------------
       */

      const itemWidths =
        items.map(function (item) {

          item.style.flex =
            '0 0 auto';

          item.style.width =
            'max-content';

          item.style.maxWidth =
            'none';

          return item.getBoundingClientRect().width;

        });


      /*
       * ------------------------------------------------------
       * Measure + MORE button
       * ------------------------------------------------------
       *
       * We temporarily display it because
       * the button itself requires space.
       * ------------------------------------------------------
       */

      moreWrapper.style.display =
        'flex';


      moreWrapper.style.flex =
        '0 0 auto';


      const moreButtonWidth =
        moreWrapper.getBoundingClientRect().width;


      /*
       * Hide it again while calculating.
       */

      moreWrapper.style.display =
        'none';


      /*
       * ------------------------------------------------------
       * Find how many notes fit
       * ------------------------------------------------------
       */

      let visibleCount = 0;

      let usedWidth = 0;


      for (
        let i = 0;
        i < itemWidths.length;
        i++
      ) {

        const noteWidth =
          itemWidths[i];


        const newWidth =
          usedWidth +
          noteWidth +
          (
            visibleCount > 0
              ? gap
              : 0
          );


        /*
         * First check whether ALL remaining notes
         * can fit without the More button.
         */

        if (
          newWidth <= availableWidth
        ) {

          usedWidth =
            newWidth;

          visibleCount++;

          continue;

        }


        /*
         * This note does not fit.
         *
         * Therefore everything from this note onward
         * will be placed inside More.
         */

        break;

      }


      /*
       * ------------------------------------------------------
       * If everything fits
       * ------------------------------------------------------
       */

      if (
        visibleCount >= items.length
      ) {

        items.forEach(function (item) {

          item.style.display =
            '';

          item.style.flex =
            '0 0 auto';

          item.style.width =
            'max-content';

          item.style.maxWidth =
            'none';

        });


        moreWrapper.style.display =
          'none';


        return;

      }


      /*
       * ------------------------------------------------------
       * Some notes overflow.
       *
       * We now need to make sure there is enough room
       * for +X More.
       * ------------------------------------------------------
       */

      let finalVisibleCount =
        visibleCount;


      /*
       * If notes are currently taking too much space
       * after adding the More button, remove notes
       * from the end until everything fits.
       */

      /*
 * Always keep at least ONE note visible.
 */
    while (
    finalVisibleCount > 1
    ) {

    let requiredWidth = 0;

    for (
        let i = 0;
        i < finalVisibleCount;
        i++
    ) {

        if (i > 0) {
        requiredWidth += gap;
        }

        requiredWidth += itemWidths[i];

    }

    /*
    * Space between last visible note
    * and +More button
    */
    requiredWidth += gap;

    requiredWidth += moreButtonWidth;


    /*
    * If everything fits, stop.
    */
    if (
        requiredWidth <= availableWidth
    ) {

        break;

    }


    /*
    * Remove one visible item,
    * but NEVER go below 1.
    */
    finalVisibleCount--;

    }

    /*
    * Final safety:
    * at least one note must always remain visible.
    */
    finalVisibleCount = Math.max(
    1,
    finalVisibleCount
    );


      /*
       * ------------------------------------------------------
       * Hide overflowing notes
       * ------------------------------------------------------
       */

      items.forEach(function (
        item,
        index
      ) {

        if (
          index < finalVisibleCount
        ) {

          item.style.display =
            '';

          item.style.flex =
            '0 0 auto';

          item.style.width =
            'max-content';

          item.style.maxWidth =
            'none';

        } else {

          item.style.display =
            'none';

        }

      });


      /*
       * ------------------------------------------------------
       * Number of hidden notes
       * ------------------------------------------------------
       */

      const hiddenCount =
        items.length -
        finalVisibleCount;


      /*
       * ------------------------------------------------------
       * Show +X More
       * ------------------------------------------------------
       */

      if (
        hiddenCount > 0
      ) {

        moreWrapper.style.display =
          'flex';


        if (moreCount) {

          moreCount.textContent =
            hiddenCount;

        }


        /*
         * ----------------------------------------------------
         * Build tooltip
         * ----------------------------------------------------
         */

        for (
          let i = finalVisibleCount;
          i < items.length;
          i++
        ) {

          const item =
            items[i];


          const tooltipItem =
            document.createElement(
              'div'
            );


          tooltipItem.className =
            'scent-tooltip-item';


          /*
           * Image
           */

          const image =
            item.querySelector(
              '.scent-note-image img'
            );


          if (image) {

            const tooltipImage =
              document.createElement(
                'img'
              );


            tooltipImage.src =
              image.src;


            tooltipImage.alt =
              image.alt || '';


            tooltipItem.appendChild(
              tooltipImage
            );

          }


          /*
           * Name
           */

          const name =
            item.querySelector(
              '.scent-note-name'
            );


          if (name) {

            const tooltipName =
              document.createElement(
                'span'
              );


            tooltipName.textContent =
              name.textContent.trim();


            tooltipItem.appendChild(
              tooltipName
            );

          }


          tooltip.appendChild(
            tooltipItem
          );

        }

      }

    });

  }


  /*
   * ==========================================================
   * INITIALIZE
   * ==========================================================
   */

  function initScentNotes() {

    /*
     * Give Shopify/theme fonts and images a moment
     * to finish loading before measuring.
     */

    setTimeout(
      updateScentNotes,
      100
    );


    setTimeout(
      updateScentNotes,
      500
    );


    setTimeout(
      updateScentNotes,
      1000
    );

  }


  /*
   * Run when DOM is ready
   */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initScentNotes
    );

  } else {

    initScentNotes();

  }


  /*
   * ==========================================================
   * RECALCULATE ON RESIZE
   * ==========================================================
   */

  let resizeTimer;


  window.addEventListener(
    'resize',
    function () {

      clearTimeout(
        resizeTimer
      );


      resizeTimer =
        setTimeout(
          updateScentNotes,
          100
        );

    }
  );


  /*
   * ==========================================================
   * RECALCULATE WHEN IMAGES LOAD
   * ==========================================================
   */

  document
    .querySelectorAll(
      '.scent-note-image img'
    )
    .forEach(function (image) {

      image.addEventListener(
        'load',
        updateScentNotes
      );

    });


  /*
   * ==========================================================
   * OPEN / CLOSE MORE TOOLTIP
   * ==========================================================
   */

  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target.closest(
          '.scent-notes-view-more'
        );


      /*
       * Close all other tooltips
       */

      document
        .querySelectorAll(
          '.scent-notes-more-wrapper.is-open'
        )
        .forEach(function (
          wrapper
        ) {

          if (
            !button ||
            !wrapper.contains(button)
          ) {

            wrapper.classList.remove(
              'is-open'
            );


            const wrapperButton =
              wrapper.querySelector(
                '.scent-notes-view-more'
              );


            if (wrapperButton) {

              wrapperButton.setAttribute(
                'aria-expanded',
                'false'
              );

            }

          }

        });


      /*
       * Open clicked tooltip
       */

      if (button) {

        const wrapper =
          button.closest(
            '.scent-notes-more-wrapper'
          );


        const isOpen =
          wrapper.classList.toggle(
            'is-open'
          );


        button.setAttribute(
          'aria-expanded',
          isOpen
            ? 'true'
            : 'false'
        );

      }

    }
  );


})();